import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from './ui-x';

/**
 * Drill-down back link, per the reference's talent detail pages
 * (talent.payslips.$id.tsx:30). Sits above SectionHeader as the first child of
 * PageShell.
 */
const BackLink = ({
  to,
  label,
  className,
}: {
  to: string;
  label: string;
  className?: string;
}) => (
  <Link
    to={to}
    className={cn(
      '-mb-2 inline-flex w-fit items-center gap-1 text-xs font-semibold text-brand-navy transition-colors hover:text-brand-orange',
      className
    )}
  >
    <ArrowLeft className='h-3.5 w-3.5' />
    {label}
  </Link>
);

export default BackLink;
